window.initGbCalorieCalculator = function(config) {
  var root = document.getElementById('gbCalc-' + config.sectionId);
  if (!root || root.__gbInit) return;
  root.__gbInit = true;

  var translations = config.translations;
  var PLAN_LINKS = config.planLinks;
  var lang = config.locale;

  var STEP_HINTS = { 1: translations.gender, 2: translations.about, 3: translations.steps, 4: translations.goal, 5: translations.pace };
  var GOAL_LABEL = { lose: translations.goals.lose, define: translations.goals.define, maintain: translations.goals.maintain, gain: translations.goals.gain };
  var TOTAL_STEPS = 5;

  /* Pace × Goal → kcal Adjustment (NICHT ÄNDERN ohne Rücksprache mit Laura) */
  var PACE_ADJ = {
    lose:     { gentle: -300, moderate: -500, sporty: -700 },
    define:   { gentle: -100, moderate: -200, sporty: -300 },
    maintain: { gentle:    0, moderate:    0, sporty:    0 },
    gain:     { gentle: +200, moderate: +300, sporty: +500 }
  };

  /* Dynamische Tile-Labels für Step 5 — passt sich an gewähltes Ziel an */
  var PACE_DESC = translations.paceDescs;
  var PACE_LABEL = { gentle: translations.paces.gentle, moderate: translations.paces.moderate, sporty: translations.paces.sporty };

  /* Goal-spezifische Beschreibung für die "Warum dieser Plan"-Narrative */
  var GOAL_BENEFIT = translations.benefits;

  /* BMR-Berechnung: Mittel aus Mifflin-St-Jeor und Harris-Benedict (1984 rev.)
     NICHT ÄNDERN ohne Rücksprache mit Laura — wissenschaftlich abgesichert. */
  function calculateBMR(sex, kg, cm, age){
    var mifflin = (sex === 'female')
      ? (10 * kg + 6.25 * cm - 5 * age - 161)
      : (10 * kg + 6.25 * cm - 5 * age + 5);
    var harrisBenedict = (sex === 'female')
      ? (447.593 + 9.247 * kg + 3.098 * cm - 4.330 * age)
      : (88.362 + 13.397 * kg + 4.799 * cm - 5.677 * age);
    return (mifflin + harrisBenedict) / 2;
  }

  /* PAL-Lookup nach Tagesschritten (kommt direkt von Laura — NICHT ÄNDERN) */
  function palFromSteps(s){
    if (s < 5000) return { pal: 1.35, label: translations.palLabels.wenig };
    if (s < 6000) return { pal: 1.4,  label: translations.palLabels.leicht };
    if (s < 7000) return { pal: 1.45, label: translations.palLabels.leicht };
    if (s < 8000) return { pal: 1.5,  label: translations.palLabels.moderat };
    if (s < 10000) return { pal: 1.55, label: translations.palLabels.moderat };
    if (s < 12500) return { pal: 1.6,  label: translations.palLabels.aktiv };
    if (s < 15000) return { pal: 1.7,  label: translations.palLabels.sehr };
    if (s < 20000) return { pal: 1.8,  label: translations.palLabels.sehr };
    return { pal: 2.0, label: translations.palLabels.extrem };
  }

  function buildWhy(plan, goal, steps, activityLabel){
    var localeStr = lang === 'de' ? 'de-CH' : (lang === 'fr' ? 'fr-CH' : 'en-US');
    var suffixStr = lang === 'de' ? 'Schritte/Tag' : (lang === 'fr' ? 'pas/jour' : 'steps/day');
    var stepsTxt = steps.toLocaleString(localeStr) + ' ' + suffixStr;
    var lifestyle = activityLabel.toLowerCase();
    var benefit = GOAL_BENEFIT[goal] || '';
    var paceTxt = (goal !== 'maintain' && state.pace) ? translations.whyPace.replace('{pace}', PACE_LABEL[state.pace]) : '';
    return translations.whyTemplate
      .replace('{steps}', stepsTxt)
      .replace('{lifestyle}', lifestyle)
      .replace('{goal}', GOAL_LABEL[goal])
      .replace('{pace}', paceTxt)
      .replace('{plan}', plan.toLocaleString(localeStr))
      .replace('{benefit}', benefit);
  }

  var state = { step: 1, gender: null, age: null, height: null, weight: null, steps: null, activity: null, goal: null, pace: 'moderate' };

  var q = function(sel){ return root.querySelector(sel); };
  var qa = function(sel){ return root.querySelectorAll(sel); };
  var stepsEls = qa('.gb-calc__step');
  var dots = qa('.gb-calc__dot');
  var stepLabel = q('[data-gb="step-label"]');
  var stepHint = q('[data-gb="step-hint"]');
  var btnBack = q('[data-gb="back"]');
  var btnNext = q('[data-gb="next"]');
  var nav = q('[data-gb="nav"]');
  var ageInput = q('[data-gb="age"]');
  var heightInput = q('[data-gb="height"]');
  var weightInput = q('[data-gb="weight"]');
  var personalError = q('[data-gb="personal-error"]');
  var stepsInput = q('[data-gb="steps"]');
  var stepsError = q('[data-gb="steps-error"]');
  var stepsPill = q('[data-gb="steps-label"]');
  var restartBtn = q('[data-gb="restart"]');
  var cta = q('[data-gb="result-cta"]');

  function effectiveTotalSteps(){ return (state.goal === 'maintain') ? 4 : TOTAL_STEPS; }
  function paceSkipped(){ return state.goal === 'maintain'; }

  function updateDots(n){
    var totalEff = effectiveTotalSteps();
    var dot5 = root.querySelector('.gb-calc__dot[data-dot="5"]');
    if (dot5) dot5.style.display = paceSkipped() ? 'none' : '';
    dots.forEach(function(d){
      var i = parseInt(d.dataset.dot, 10);
      d.classList.remove('is-active','is-done');
      if (n === 'result' && i <= totalEff) d.classList.add('is-done');
      else if (typeof n === 'number' && i < n) d.classList.add('is-done');
      if (typeof n === 'number' && i === n) d.classList.add('is-active');
    });
  }

  function setStep(n){
    state.step = n;
    stepsEls.forEach(function(el){
      el.classList.toggle('is-active', el.dataset.step == String(n) || (n === 'result' && el.dataset.step === 'result'));
    });
    if (n === 'result') {
      updateDots('result');
      stepLabel.textContent = translations.stepLabelDone;
      stepHint.textContent = translations.stepHintResult;
      nav.classList.add('is-hidden');
    } else {
      updateDots(n);
      var totalEff = effectiveTotalSteps();
      stepLabel.textContent = translations.stepOf.replace('{step}', n).replace('{total}', totalEff);
      stepHint.textContent = STEP_HINTS[n] || '';
      nav.classList.remove('is-hidden');
      btnBack.classList.toggle('is-hidden', n === 1);
      if (n === 5) updatePaceTileLabels();
      updateNextEnabled();
    }
  }

  function updatePaceTileLabels(){
    if (!state.goal || !PACE_DESC[state.goal]) return;
    var descs = PACE_DESC[state.goal];
    ['gentle','moderate','sporty'].forEach(function(pace){
      var descEl = root.querySelector('[data-pace-desc="' + pace + '"]');
      var metaEl = root.querySelector('[data-pace-meta="' + pace + '"]');
      if (descEl && descs[pace]) descEl.textContent = descs[pace].desc;
      if (metaEl && descs[pace]) metaEl.textContent = descs[pace].meta;
    });
    var paceStep = root.querySelector('.gb-calc__step[data-key="pace"]');
    paceStep.querySelectorAll('.gb-calc__tile').forEach(function(t){ t.classList.remove('is-selected'); });
    var defaultTile = paceStep.querySelector('.gb-calc__tile[data-value="' + (state.pace || 'moderate') + '"]');
    if (defaultTile) defaultTile.classList.add('is-selected');
  }

  function updateNextEnabled(){
    var s = state.step;
    var personalOk = state.age && state.age >= 16 && state.age <= 100
      && state.height && state.height >= 130 && state.height <= 220
      && state.weight && state.weight >= 35 && state.weight <= 200;
    var lastStep = (state.goal === 'maintain') ? 4 : TOTAL_STEPS;
    var ok =
      (s === 1 && state.gender) ||
      (s === 2 && personalOk) ||
      (s === 3 && state.steps !== null && state.steps >= 0 && state.steps <= 50000) ||
      (s === 4 && state.goal) ||
      (s === 5 && state.pace);
    btnNext.disabled = !ok;
    btnNext.textContent = (s === lastStep) ? translations.calculate : translations.next;
  }

  function selectTile(stepKey, value){
    var stepEl = root.querySelector('.gb-calc__step[data-key="' + stepKey + '"]');
    if (!stepEl) return;
    stepEl.querySelectorAll('.gb-calc__tile').forEach(function(t){ t.classList.remove('is-selected'); });
    var picked = stepEl.querySelector('.gb-calc__tile[data-value="' + value + '"]');
    if (picked) picked.classList.add('is-selected');
    state[stepKey] = value;
    updateNextEnabled();
  }

  qa('.gb-calc__tile[data-value]').forEach(function(tile){
    tile.addEventListener('click', function(){
      var stepEl = tile.closest('.gb-calc__step');
      var key = stepEl.dataset.key;
      selectTile(key, tile.dataset.value);
      setTimeout(function(){
        // maintain überspringt Step 5 (Pace nicht nötig)
        if (state.step === 4 && state.goal === 'maintain') {
          calculate();
        } else if (state.step < TOTAL_STEPS) {
          setStep(state.step + 1);
        } else {
          calculate();
        }
      }, 220);
    });
  });

  /* Personal data inputs */
  function validatePersonal(){
    var errs = [];
    if (state.age !== null) {
      if (state.age < 16) errs.push(translations.personalErrorAge);
      else if (state.age > 100) errs.push(translations.personalErrorAgeMax);
    }
    if (state.height !== null) {
      if (state.height < 130) errs.push(translations.personalErrorHeight);
      else if (state.height > 220) errs.push(translations.personalErrorHeightMax);
    }
    if (state.weight !== null) {
      if (state.weight < 35) errs.push(translations.personalErrorWeight);
      else if (state.weight > 200) errs.push(translations.personalErrorWeightMax);
    }
    personalError.textContent = errs.length ? errs[0] : '';
  }
  ageInput.addEventListener('input', function(){
    var raw = (ageInput.value || '').replace(/[^0-9]/g, '');
    state.age = raw === '' ? null : parseInt(raw, 10);
    validatePersonal(); updateNextEnabled();
  });
  heightInput.addEventListener('input', function(){
    var raw = (heightInput.value || '').replace(/[^0-9]/g, '');
    state.height = raw === '' ? null : parseInt(raw, 10);
    validatePersonal(); updateNextEnabled();
  });
  weightInput.addEventListener('input', function(){
    var raw = (weightInput.value || '').replace(',', '.');
    var val = parseFloat(raw);
    state.weight = isNaN(val) ? null : val;
    validatePersonal(); updateNextEnabled();
  });
  [ageInput, heightInput, weightInput].forEach(function(inp){
    inp.addEventListener('keydown', function(e){
      if (e.key === 'Enter' && !btnNext.disabled) { e.preventDefault(); btnNext.click(); }
    });
  });

  /* Steps input */
  stepsInput.addEventListener('input', function(){
    var raw = (stepsInput.value || '').replace(/[^0-9]/g, '');
    var val = raw === '' ? null : parseInt(raw, 10);
    if (val === null || isNaN(val)) {
      state.steps = null; state.activity = null;
      stepsError.textContent = ''; stepsPill.hidden = true;
    } else if (val > 50000) {
      state.steps = null; state.activity = null;
      stepsError.textContent = translations.stepsError;
      stepsPill.hidden = true;
    } else {
      state.steps = val;
      var p = palFromSteps(val);
      state.activity = p.pal;
      stepsError.textContent = '';
      stepsPill.textContent = p.label;
      stepsPill.hidden = false;
    }
    updateNextEnabled();
  });
  stepsInput.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && !btnNext.disabled) { e.preventDefault(); btnNext.click(); }
  });

  /* Quick-pick chips for steps */
  qa('.gb-calc__chip').forEach(function(chip){
    chip.addEventListener('click', function(){
      var v = chip.dataset.steps;
      stepsInput.value = v;
      stepsInput.dispatchEvent(new Event('input', { bubbles: true }));
      stepsInput.focus({ preventScroll: true });
    });
  });

  /* Info tooltips on Grundumsatz/Leistungsumsatz */
  var activeTip = null;
  function closeTip(){ if (activeTip) { activeTip.parentNode && activeTip.parentNode.removeChild(activeTip); activeTip = null; } }
  qa('.gb-calc__info').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      closeTip();
      var tip = document.createElement('div');
      tip.id = 'gbCalc-' + config.sectionId + '-tip';
      tip.className = 'gb-calc-tooltip';
      tip.textContent = btn.dataset.tip;
      document.body.appendChild(tip);
      activeTip = tip;
    });
  });
  document.addEventListener('click', function(e){
    if (activeTip && !e.target.classList.contains('gb-calc__info')) closeTip();
  });

  btnBack.addEventListener('click', function(){ if (state.step > 1) setStep(state.step - 1); });
  btnNext.addEventListener('click', function(){
    if (state.step === 4 && state.goal === 'maintain') {
      calculate();
    } else if (state.step < TOTAL_STEPS) {
      setStep(state.step + 1);
    } else {
      calculate();
    }
  });

  /* === CALCULATION === */
  function calculate(){
    var pal = state.activity, goal = state.goal, pace = state.pace || 'moderate';
    var bmr = calculateBMR(state.gender, state.weight, state.height, state.age);
    var tdee = bmr * pal;
    var adj = (PACE_ADJ[goal] && typeof PACE_ADJ[goal][pace] === 'number') ? PACE_ADJ[goal][pace] : 0;
    var target = tdee + adj;
    var rounded = Math.round(target / 100) * 100;
    var plan = Math.max(1500, Math.min(2500, rounded));
    state.calculatedPlan = plan;
    var clampedHigh = rounded > 2500;
    var clampedLow = rounded < 1500;

    var localeStr = lang === 'de' ? 'de-CH' : (lang === 'fr' ? 'fr-CH' : 'en-US');
    q('[data-gb="result-bmr"]').textContent = Math.round(bmr).toLocaleString(localeStr) + ' kcal';
    q('[data-gb="result-tdee"]').textContent = Math.round(tdee).toLocaleString(localeStr) + ' kcal';
    q('[data-gb="result-adj"]').textContent = (adj > 0 ? '+' : '') + adj.toLocaleString(localeStr) + ' kcal';

    var kcalEl = q('[data-gb="result-kcal"]');
    var contextEl = q('[data-gb="result-context"]');
    var planEl = q('[data-gb="result-plan"]');
    var trainingEl = q('[data-gb="training-info"]');
    var trainingTitle = q('[data-gb="training-title"]');
    var trainingDesc = q('[data-gb="training-desc"]');
    var whyEl = q('[data-gb="result-why"]');
    var stepsInfo = palFromSteps(state.steps);

    if (clampedHigh) {
      // Show TRUE need as the big number, not the clamped plan
      kcalEl.textContent = rounded.toLocaleString(localeStr);
      contextEl.textContent = translations.calculatedNeed;
      planEl.innerHTML = translations.clampedHighPlan;
      trainingEl.classList.add('is-clamped');
      trainingTitle.textContent = translations.clampedHighTitle;
      trainingDesc.textContent = translations.clampedHighDesc.replace('{diff}', rounded - 2500);
      cta.innerHTML = translations.ctaTextClampedHigh + ' <span class="gb-calc__cta-arrow" aria-hidden="true">→</span>';
      cta.href = PLAN_LINKS[2500] || '#';
      whyEl.innerHTML = buildWhy(2500, goal, state.steps, stepsInfo.label);
    } else if (clampedLow) {
      kcalEl.textContent = (1500).toLocaleString(localeStr);
      contextEl.textContent = translations.recommendedMin;
      planEl.textContent = translations.clampedLowPlan + GOAL_LABEL[goal];
      trainingEl.classList.remove('is-clamped');
      trainingTitle.textContent = translations.clampedLowTitle;
      trainingDesc.textContent = translations.clampedLowDesc;
      cta.innerHTML = translations.ctaTextClampedLow + ' <span class="gb-calc__cta-arrow" aria-hidden="true">→</span>';
      cta.href = PLAN_LINKS[1500] || '#';
      whyEl.innerHTML = buildWhy(1500, goal, state.steps, stepsInfo.label);
    } else {
      kcalEl.textContent = plan.toLocaleString(localeStr);
      contextEl.textContent = translations.withoutSport;
      planEl.textContent = translations.standardPlan + GOAL_LABEL[goal];
      trainingEl.classList.remove('is-clamped');
      trainingTitle.textContent = translations.trainingTitle;
      trainingDesc.textContent = translations.trainingDesc;
      cta.innerHTML = translations.ctaText.replace('{plan}', plan) + ' <span class="gb-calc__cta-arrow" aria-hidden="true">→</span>';
      cta.href = PLAN_LINKS[plan] || '#';
      whyEl.innerHTML = buildWhy(plan, goal, state.steps, stepsInfo.label);
    }

    setStep('result');

    /* Optional: dataLayer Event für GA4/GTM */
    try {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'goldenbody_calc_result',
          gb_plan: plan,
          gb_real_need: rounded,
          gb_clamped: clampedHigh ? 'high' : (clampedLow ? 'low' : 'no'),
          gb_gender: state.gender,
          gb_age: state.age,
          gb_height: state.height,
          gb_weight: state.weight,
          gb_steps: state.steps,
          gb_pal: state.activity,
          gb_goal: goal,
          gb_pace: pace
        });
      }
    } catch(e){}
  }

  restartBtn.addEventListener('click', function(){
    state = { step: 1, gender: null, age: null, height: null, weight: null, steps: null, activity: null, goal: null, pace: 'moderate' };
    ageInput.value = ''; heightInput.value = ''; weightInput.value = ''; personalError.textContent = '';
    stepsInput.value = ''; stepsError.textContent = ''; stepsPill.hidden = true;
    qa('.gb-calc__tile.is-selected').forEach(function(t){ t.classList.remove('is-selected'); });
    setStep(1);
  });

  if (cta) {
    cta.addEventListener('click', function(e) {
      e.preventDefault();
      if (state.calculatedPlan) {
        selectVariantOnPage(state.calculatedPlan);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function selectVariantOnPage(planValue) {
    var regex = new RegExp(planValue + '\\s*kcal', 'i');
    
    // 1. Radio buttons, labels, buttons, spans
    var elements = document.querySelectorAll('label, input[type="radio"], button, span, legend');
    var foundElement = null;
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el.closest('.gb-calc')) continue;
      var text = (el.textContent || el.value || '').trim();
      if (regex.test(text)) {
        foundElement = el;
        break;
      }
    }

    if (foundElement) {
      foundElement.click();
      if (foundElement.tagName === 'INPUT') {
        foundElement.checked = true;
        foundElement.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var inputId = foundElement.getAttribute('for');
        if (inputId) {
          var inputEl = document.getElementById(inputId);
          if (inputEl) {
            inputEl.click();
            inputEl.checked = true;
            inputEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      return true;
    }

    // 2. Select dropdown options
    var selects = document.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      if (sel.closest('.gb-calc')) continue;
      for (var k = 0; k < sel.options.length; k++) {
        var opt = sel.options[k];
        if (regex.test(opt.text)) {
          sel.selectedIndex = k;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }

    // 3. Custom variant elements / Swatches data-value attributes
    var dataElements = document.querySelectorAll('[data-value], [data-option-value], [data-variant-title]');
    for (var d = 0; d < dataElements.length; d++) {
      var del = dataElements[d];
      if (del.closest('.gb-calc')) continue;
      var valAttr = (del.getAttribute('data-value') || del.getAttribute('data-option-value') || del.getAttribute('data-variant-title') || '').trim();
      if (regex.test(valAttr)) {
        del.click();
        return true;
      }
    }

    return false;
  }

  setStep(1);
};
